import { useLocation, useNavigate } from 'react-router-dom'
import { ChevronLeft } from 'lucide-react'

const HOME = '/dashboard'

/** Where Back goes when there's no in-app history (a direct link or a fresh tab). */
export function fallbackPath(pathname: string): string {
  const parts = pathname.split('/').filter(Boolean)
  if (parts.length <= 1) return HOME
  return '/' + parts.slice(0, -1).join('/')
}

export function isHomePath(pathname: string): boolean {
  return pathname === '/' || pathname === HOME || pathname === `${HOME}/`
}

/**
 * App-wide Back (shared Layout). Goes back in browser history when this tab
 * already navigated inside the app; otherwise to the page's parent route.
 * Hidden on the home page.
 */
export function BackButton() {
  const location = useLocation()
  const navigate = useNavigate()
  if (isHomePath(location.pathname)) return null
  // react-router gives the first entry of a session the key "default".
  const hasInAppHistory = location.key !== 'default'
  const onClick = () => {
    if (hasInAppHistory) navigate(-1)
    else navigate(fallbackPath(location.pathname), { replace: true })
  }
  return (
    <div className="app-back-row px-4 pt-3 md:px-6" data-testid="app-back-row">
      <button
        type="button"
        onClick={onClick}
        aria-label="Back"
        className="inline-flex items-center gap-1 min-h-[44px] pr-3 text-sm rounded-full text-[color:var(--midnight-text3)] hover:text-[rgb(var(--fg-rgb))] focus-visible:outline focus-visible:outline-2"
      >
        <ChevronLeft className="w-5 h-5" aria-hidden />
        Back
      </button>
    </div>
  )
}
